// Layouts
import PageLayer from "@/Layouts/views/PageLayer";

// Layer
import Layer from "@PayPlans/views/Layers/MyPayPlans";

// Images
import Icon from "@/assets/icons/positions/MyPayPlan.svg";

export default function MyPayPlans() {
	return (
		<PageLayer title="My Pay Plans" icon={Icon}>
			<Layer />
		</PageLayer>
	);
}
